import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import mailIcon from 'icons/mailIcon.svg';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import Dialog from '../modals/Dialog';
import Button from '../buttons/Button';
import { secondary300 } from '../../themes/colors';

const styles = () => ({
  spanSection: {
    display: 'inline-block',
    textAlign: 'center',
    paddingBottom: '1rem',
  },
  buttonsSection: {
    paddingTop: '1rem',
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  mailIcon: {
    textAlign: 'center',
    marginTop: '0.5rem',
    marginBottom: '1rem',
  },
  closeIcon: {
    position: 'absolute',
    right: '1.125rem',
    top: '0.875rem',
    width: '1.375rem',
    color: secondary300,
    cursor: 'pointer',
  },
});

const CustomizedEmailModal = ({
  classes, customizedEmailModalOpen, toggleCustomizedEmailModal, customizedEmails,
  overwriteCustomizedEmail,
}) => (
  <Dialog
    open={customizedEmailModalOpen}
    size="small"
  >
    <CloseRoundedIcon onClick={toggleCustomizedEmailModal} classes={{ root: classes.closeIcon }} />
    <div className={classes.mailIcon}>
      <img src={mailIcon} alt="mail_icon" />
    </div>
    <span className={classes.spanSection}>
      You have {customizedEmails} customized emails, do you want to overwrite them as well?
    </span>
    <div className={classes.buttonsSection}>
      <Button
        color="secondary"
        variant="text"
        onClick={() => overwriteCustomizedEmail(false)}
      >
        Don’t update
      </Button>
      <Button
        color="primary"
        variant="contained"
        className="ml-2"
        onClick={() => overwriteCustomizedEmail(true)}
      >
        Yes, overwrite
      </Button>
    </div>
  </Dialog>
);

CustomizedEmailModal.propTypes = {
  classes: PropTypes.element.isRequired,
  customizedEmailModalOpen: PropTypes.bool.isRequired,
  toggleCustomizedEmailModal: PropTypes.func.isRequired,
  customizedEmails: PropTypes.number.isRequired,
  overwriteCustomizedEmail: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(CustomizedEmailModal);
